import EmployeesList from './_EmployeesList';

export default EmployeesList;
